import { render, staticRenderFns } from "./News.vue?vue&type=template&id=8f5b60ea&"
import script from "./News.vue?vue&type=script&lang=js&"
export * from "./News.vue?vue&type=script&lang=js&"
import style0 from "./News.vue?vue&type=style&index=0&id=8f5b60ea&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8f5b60ea')) {
      api.createRecord('8f5b60ea', component.options)
    } else {
      api.reload('8f5b60ea', component.options)
    }
    module.hot.accept("./News.vue?vue&type=template&id=8f5b60ea&", function () {
      api.rerender('8f5b60ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/common/dashboard/panels/News.vue"
export default component.exports